/**
 * 解析相关问题工具函数
 * 从 SSE 返回的 answer 中提取相关问题和答案
 */

/**
 * 解析相关问题
 * @param {string} answer - SSE 返回的完整答案文本
 * @returns {Array<{title: string, content: string}>} 相关问题数组
 *
 * 新格式示例：
 * 相关问题：
 * [{"title":"问题1","content":"<p>答案1</p>"},{"title":"问题2","content":"<p>答案2</p>"}]
 */
export function parseRelatedQuestions(answer) {
  if (!answer || typeof answer !== 'string') {
    return [];
  }

  // 查找"相关问题："标记
  const marker = '相关问题：';
  const markerIndex = answer.indexOf(marker);

  if (markerIndex === -1) {
    return [];
  }

  // 提取相关问题部分的文本（标记后的内容）
  const relatedQuestionsText = answer.substring(markerIndex + marker.length).trim();

  if (!relatedQuestionsText) {
    return [];
  }

  try {
    // 尝试解析JSON数组
    const raw = JSON.parse(relatedQuestionsText);
    
    if (!Array.isArray(raw)) {
      console.warn('相关问题数据格式错误：不是数组', raw);
      return [];
    }

    // 兼容两种格式：
    // 1. [{title: '...', content: '...'}]
    // 2. ["{\"title\":\"...\",\"content\":\"...\"}", ...]
    const questions = raw.map(item => {
      // 如果是字符串，尝试再做一次 JSON 解析
      if (typeof item === 'string') {
        try {
          return JSON.parse(item);
        } catch (e) {
          console.warn('解析单个相关问题字符串失败:', e, item);
          return null;
        }
      }
      return item;
    });

    // 验证并格式化数据
    return questions
      .filter(item => item && typeof item === 'object' && item.title && item.content)
      .map(item => ({
        title: String(item.title).trim(),
        content: String(item.content).trim()
      }));
  } catch (error) {
    console.warn('解析相关问题JSON失败:', error, relatedQuestionsText);
    return [];
  }
}

/**
 * 从答案中移除相关问题部分
 * @param {string} answer - SSE 返回的完整答案文本
 * @returns {string} 移除相关问题后的答案文本
 */
export function removeRelatedQuestions(answer) {
  if (!answer || typeof answer !== 'string') {
    return answer || '';
  }

  // 查找"相关问题："标记
  const marker = '相关问题：';
  const markerIndex = answer.indexOf(marker);

  if (markerIndex === -1) {
    return answer;
  }

  // 返回标记之前的内容（正常回答部分）
  return answer.substring(0, markerIndex).trim();
}
